import { FC } from 'react';
import { useTranslation } from 'mir-utils/i18n';

export const IconLogo: FC<{ path: string }> = ({ path }) => {
  const { t } = useTranslation();
  return <img src={path} alt={t('Logo')} />;
};
